import Html from 'slate-html-serializer';

import { answerLinkRules } from './rules/answer_link_rules';
import { basePasteRules } from './rules/base_paste_rules';
import { fallbackRules } from './rules/fallback_rules';
import { placeholderRules } from './rules/placeholder_rules';
import { richTextRules } from './rules/rich_text_rules';
import { variableRules } from './rules/variable_rules';

const PasteSerializer = new Html({
  rules: [
    ...basePasteRules,
    ...answerLinkRules,
    ...placeholderRules,
    ...richTextRules,
    ...variableRules,
    ...fallbackRules,
  ],
});

export default PasteSerializer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/serializers/paste_serializer.jsx